// src/components/users/UserEditField.js
import { useState } from 'react';
import api from '../../services/api';

const UserEditField = ({ user, field, label, value, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (editValue === value) {
      setIsEditing(false);
      return;
    }

    setLoading(true);
    setError('');
    try {
      await api.patch(`/user/${user.id}`, { [field]: editValue });
      onSave(field, editValue);
      setIsEditing(false);
    } catch (err) {
      const errorMsg = err.response?.data?.error || `Ошибка при сохранении ${label.toLowerCase()}`;
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-edit-field">
      {isEditing ? (
        <div className="edit-mode">
          <input
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onBlur={handleSave}
            onKeyPress={(e) => e.key === 'Enter' && handleSave()}
            autoFocus
            className="form-control"
          />
          {error && <div className="text-danger small">{error}</div>}
          {loading && <div className="text-muted small">Сохранение...</div>}
        </div>
      ) : (
        <div className="view-mode">
          <span className="value">{value || '—'}</span>
          <button
            type="button"
            className="edit-btn"
            onClick={() => setIsEditing(true)}
            title={`Редактировать ${label.toLowerCase()}`}
          >
            ✎
          </button>
        </div>
      )}
    </div>
  );
};

export default UserEditField;